import React, { useState } from "react";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import cancel from "../assets/images/navbar/cancel.png";
import { FAQ_DATA } from "../data/staticContent";

type FAQsProps = {
  onClose: () => void;
};

const FAQs = ({ onClose }: FAQsProps) => {
  const [openId, setOpenId] = useState<string | null>(FAQ_DATA[0]?.id || null);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[70]" onClick={onClose}>
      <div
        className="fixed right-0 top-0 h-full w-full max-w-[450px] bg-white dark:bg-gray-900 rounded-l-[20px] overflow-y-auto"
        style={{ animation: "slideInRight 0.3s ease-out" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white dark:bg-gray-900 z-10 px-6 py-4 border-b dark:border-gray-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img src={arrowLeft} alt="back" className="w-[36px] h-[36px] rounded-full border cursor-pointer p-2" onClick={onClose} />
              <h2 className="text-[#040404] dark:text-gray-200 font-Urbanist text-[20px] font-semibold">FAQs</h2>
            </div>
            <img src={cancel} alt="close" className="w-[36px] h-[36px] p-2 rounded-full border cursor-pointer" onClick={onClose} />
          </div>
        </div>
        <div className="px-6 py-4 space-y-3">
          {FAQ_DATA.map((item) => (
            <div key={item.id} className="border dark:border-gray-700 rounded-xl overflow-hidden">
              <button
                className="w-full text-left px-4 py-3 font-Urbanist font-semibold text-[#050505] dark:text-gray-200"
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
              >
                {item.question}
              </button>
              {openId === item.id && (
                <p className="px-4 pb-4 text-sm text-[#6A6A6A] dark:text-gray-400">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQs;
